import { render, staticRenderFns } from "./PRO_TrendingByCoder.vue?vue&type=template&id=3dfeac80&scoped=true&"
import script from "./PRO_TrendingByCoder.vue?vue&type=script&lang=js&"
export * from "./PRO_TrendingByCoder.vue?vue&type=script&lang=js&"
import style0 from "./PRO_TrendingByCoder.vue?vue&type=style&index=0&id=3dfeac80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfeac80",
  null
  
)

export default component.exports